import React from 'react';
import { TWConfirmModal } from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';

export default function PaymentModal({
  show,
  onClose,
  companies,
  onSubmit,
  loading,
}) {
  const total = companies.reduce(
    (sum, company) => sum + (company.balance || 0),
    0,
  );

  return (
    <TWConfirmModal
      open={show}
      onClose={onClose}
      onConfirm={onSubmit}
      tone="warning"
      title="Pay Now"
      description="Are you sure you want to pay now?"
      confirmLabel="Pay Now"
      cancelLabel="Cancel"
      loading={loading}
    >
      <p className="pt-2 text-sm font-bold text-slate-900 dark:text-slate-100">
        Total: {formatCurrency(total)}
      </p>
    </TWConfirmModal>
  );
}
